<!-- <app-nav-bar /> -->

@if(itsLoading()) {
    <div class="grid place-items-center w-screen h-screen fixed bg-black top-[0px] left-[0px] z-2104 opacity-75">
        <ng-lottie [options]="lottieLoader"></ng-lottie>
    </div>
}

<div>
    <router-outlet></router-outlet>
</div>

<p-toast 
    [position]="position()" 
    key="myGlobalToast" 
    (onClose)="clearToast()"
    [class.hidden]="!toastVisible()"
/>
